import { render } from "./terms-page.vue?vue&type=template&id=ea8a85be&scoped=true"
const script = {}

import "./terms-page.vue?vue&type=style&index=0&id=ea8a85be&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8a85be"]])

export default __exports__